import { FC } from 'react';
import { DetailsBooking } from 'types';
import { useModal } from 'lib/hooks';
import { FormattedName } from 'components/Formatters';
import { ContentHeading } from 'components/Typography';
import EditButton from './components/EditButton';
import GuestInformationCard from '../GuestInformationCard';
import GuestDetailsModal, { GuestAmendmentProvider } from 'components/GuestDetailsModal';

interface GuestInformationProps {
  booking: DetailsBooking;
}

const GuestInformation: FC<GuestInformationProps> = ({ booking }) => {
  const { reservation, travelArranger } = booking;
  const leadGuestName = <FormattedName name={reservation.leadGuest.name} />;

  const {
    openModal,
    closeModal,
    modalProps: { isOpen },
  } = useModal();

  return (
    <>
      <ContentHeading>
        Guest information <EditButton booking={booking} openModal={openModal} data-testid="edit-guest-information" />
      </ContentHeading>
      <GuestInformationCard
        leadGuestName={leadGuestName}
        guestQffNumber={reservation.leadGuest.qffNumber}
        guestAbnNumber={travelArranger.businessRegistrationNumber}
        guestPhoneNumber={travelArranger.phone}
        guestEmailAddress={travelArranger.email}
      />
      {isOpen ? (
        <GuestAmendmentProvider>
          <GuestDetailsModal isOpen={isOpen} closeModal={closeModal} />
        </GuestAmendmentProvider>
      ) : null}
    </>
  );
};

export default GuestInformation;
